/* Poster wall. Hover lifts a poster; selection draws a white ring. */
.catalog {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(168px, 1fr));
  gap: var(--space-4) var(--space-3);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  border-radius: var(--radius-md);
  -webkit-tap-highlight-color: transparent;
  transition: transform 90ms var(--ease-out);
}

.card:not(.ready) {
  opacity: 0.6;
}

.ready {
  cursor: pointer;
}

@media (hover: hover) {
  .ready:hover {
    transform: scale(1.05);
    z-index: 2;
  }
}

.ready:active {
  transform: scale(0.97);
}

.ready:focus-visible {
  box-shadow: var(--focus-ring);
}

.selected .poster {
  box-shadow: 0 0 0 3px var(--color-text);
}

.selected .title::before {
  content: '✓ ';
  color: var(--color-accent-text);
}

.poster {
  position: relative;
  aspect-ratio: 2 / 3;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: repeating-linear-gradient(135deg, #1c1c1c, #1c1c1c 10px, #222 10px, #222 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-subtle);
  font-size: var(--fs-xs);
  font-family: var(--font-mono);
  transition: box-shadow var(--motion-fast) var(--ease-out);
}

@media (hover: hover) {
  .ready:hover .poster {
    box-shadow: var(--shadow-card);
  }
}

.poster img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.posterPlaceholder {
  padding: var(--space-2);
}

.badge {
  position: absolute;
  top: 8px;
  left: 8px;
}

.progressBar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.progressFill {
  height: 100%;
  background: var(--color-accent);
  transition: width 0.5s ease;
}

.deleteBtn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.75);
  color: var(--color-text);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  padding: 0;
  transition: opacity var(--motion-fast) var(--ease-out), background var(--motion-fast) var(--ease-out),
    transform 60ms var(--ease-out);
}

.card:hover .deleteBtn {
  opacity: 1;
}

.deleteBtn:hover {
  background: var(--color-error);
  color: var(--color-bg);
}

.deleteBtn:active {
  transform: scale(0.88);
}

.deleteBtn:focus-visible {
  opacity: 1;
}

.confirmOverlay {
  position: absolute;
  inset: 0;
  background: rgba(10, 10, 10, 0.97);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  text-align: center;
  z-index: 2;
}

.confirmText {
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
}

.confirmActions {
  display: flex;
  gap: 8px;
}

.body {
  padding: 0 2px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.title {
  font-size: var(--fs-sm);
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meta {
  color: var(--color-text-muted);
  font-size: var(--fs-xs);
  font-variant-numeric: tabular-nums;
}

/* Touch: no hover, so the delete control is always shown and easy to hit. */
@media (hover: none) {
  .deleteBtn {
    opacity: 1;
    width: 36px;
    height: 36px;
    font-size: 22px;
  }
}

@media (max-width: 600px) {
  .catalog {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-4) var(--space-3);
  }
}
